import React, { useState } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Button from '../../../../common/button'

import { DialogLevel, useDialog } from '../../../dialog/hook'
import { Book, StatusEnum } from '../../../../../data/book/data-types'
import { ChangeStatusFunction } from '../../../../../data/hooks/change-status'
import { useAuth } from '../../../../../data/hooks/auth'

import ChangeStatusDialog from './dialog'
import { useAuthForms } from '../../auth'

type AddBookControllerProps = {
  book: Book
  changeStatus: ChangeStatusFunction
}

const AddBook: React.FunctionComponent<AddBookControllerProps> = ({ book, changeStatus }) => {
    const { user } = useAuth()
    const { t } = useTranslation("book")
    
    const { setComponent, closeDialog } = useDialog()
    const { showRegisterForm } = useAuthForms(true, () => changeBookStatus())

    const userOwnsBook = book.status_id != null

    const changeBookStatus = () => setComponent(
      <ChangeStatusDialog 
        changeStatus={async (statusId: StatusEnum, token?: string, force?: boolean) => {
          const clubId = await changeStatus(statusId, token, force)
          closeDialog(DialogLevel.Top)

          return clubId
        }} 
        statusId={book.status_id}
      />, 
      undefined, 
      DialogLevel.Top
    )

    if (userOwnsBook) {
      return <Container changeStatus={true}>
        <GoToChat onClick={() => closeDialog()} statusId={book.status_id} to={`/messages/club/cafe/${book.club_id}`}>
          {t("chat_about_book")}
        </GoToChat>
        <ChangeStatusButton 
          statusId={book.status_id} 
          onClick={changeBookStatus}
        >
          <Icon src={require('./images/library.svg')} />
        </ChangeStatusButton>
      </Container>
    }

    if (!user) {
      return <Container>
        <AddButton onClick={() => showRegisterForm()}>
          {t("chat_about_book")}
        </AddButton>
      </Container>
    }
    
    return (
        <Container>
            <AddButton onClick={changeBookStatus}>Join book club</AddButton>
        </Container>
    )
}


const Container = styled.div<{ changeStatus?: boolean }>`
  display: grid;
  width: 100%;
  grid-template-columns: ${p => p.changeStatus ? '1fr auto' : '1fr'};
  grid-column-gap: 10px;
`

const AddButton = styled(Button)`
  margin-top: 0px;
`

const GoToChat = styled(Link)<{ statusId?: StatusEnum }>`
  padding: 17px;

  width: 100%;

  font-size: 16px;
  line-height: 22px;
  font-weight: bold;
  text-align: center;

  border-radius: 333px;
  background: ${p => p.theme.statuses[p.statusId || StatusEnum.WantToRead]};

  &, &:active, &:visited {
    text-decoration: none;
    color: ${p => p.theme.colors.bg};
  }
`

const ChangeStatusButton = styled.div<{ statusId?: StatusEnum}>`
  display: grid;
  align-items: center;
  justify-content: center;

  grid-template: auto;

  height: 56px;
  width: 56px;

  border-radius: 50%;
  background: ${p => p.theme.statuses[p.statusId || StatusEnum.WantToRead]};
  cursor: pointer;
`

const Icon = styled.img`
  width: 20px;
  height: 20px;
`

export default AddBook